import React from "react";

/**
 * Reusable caret SVG.
 * Props:
 *  - size: number (px)
 *  - direction: "down" | "up" (controls rotation)
 *  - className/style: passed to SVG for styling
 *
 * Uses `currentColor` for stroke so it inherits button text color.
 */
export default function CaretIcon({ size = 12, direction = "down", className, style, ...props }) {
  const rotation = direction === "down" ? 0 : 180;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={{ transform: `rotate(${rotation}deg)`, transition: "transform .15s", ...style }}
      {...props}
    >
      <path
        d="M2 4.5 L6 8.5 L10 4.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}